import { Button, TextBlock } from '../../atoms';
import { FileIcon } from '../../atoms/FileIcon/FileIcon';
import React from 'react';
import useStyles from './FileErrorModal.styles';

interface IFileErrorModalProps {
  open?: boolean;
  headerText: string;
  text: string;
  buttonText: string;
  buttonSize?: 'small' | 'medium' | 'large';
  handleButtonClick: () => void;
}

const FileErrorModal: React.FC<IFileErrorModalProps> = ({
  open,
  headerText,
  text,
  buttonText,
  buttonSize,
  handleButtonClick,
}) => {
  const classes = useStyles();

  return (
    <>
      {open && (
        <div className={classes.root}>
          <div className={classes.iconContainer}>
            <FileIcon iconType="alertIcon" />
          </div>

          <div className={classes.title}>
            <TextBlock
              type="fileUploadTitleModalTB"
              text={headerText}
              alignCenter={true}
            />
          </div>
          <div className={classes.textContainer}>
            <TextBlock
              type="fileUploadModalTB"
              text={text}
              alignCenter={true}
            />
          </div>
          <div className={classes.buttons}>
            <Button onAction={handleButtonClick} color="blue" size={buttonSize}>
              {buttonText}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default FileErrorModal;
